/**
 * @generated SignedSource<<3b953c1e840928d1cbf93c82627a9f91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PayMyBill_viewer$data = {
  readonly currentOrders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdAt: any | null | undefined;
        readonly id: string;
        readonly rowId: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly pastOrders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdAt: any | null | undefined;
        readonly id: string;
        readonly rowId: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly unpaidOrders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly owed: number | null | undefined;
        readonly rowId: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly credit: number | null | undefined;
    readonly owed: number | null | undefined;
    readonly owedReason: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PayMyBill_viewer";
};
export type PayMyBill_viewer$key = {
  readonly " $data"?: PayMyBill_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PayMyBill_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "owed",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    [
      "id",
      "ASC"
    ]
  ]
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PayMyBill_viewer",
  "selections": [
    {
      "alias": "unpaidOrders",
      "args": [
        {
          "kind": "Literal",
          "name": "filterBy",
          "value": {
            "unpaid": true
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            [
              "cycleId",
              "DESC"
            ]
          ]
        }
      ],
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "orders(filterBy:{\"unpaid\":true},first:100,orderBy:[[\"cycleId\",\"DESC\"]])"
    },
    {
      "alias": "currentOrders",
      "args": [
        {
          "kind": "Literal",
          "name": "filterBy",
          "value": {
            "cycleId": "current"
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        },
        (v3/*: any*/)
      ],
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": "orders(filterBy:{\"cycleId\":\"current\"},first:10000,orderBy:[[\"id\",\"ASC\"]])"
    },
    {
      "alias": "pastOrders",
      "args": [
        {
          "kind": "Literal",
          "name": "filterBy",
          "value": {
            "cycleId": "past"
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        (v3/*: any*/)
      ],
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": "orders(filterBy:{\"cycleId\":\"past\"},first:1,orderBy:[[\"id\",\"ASC\"]])"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "credit",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "owedReason",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "d59fcf49a6b9b11681dace0681f164c9";

export default node;
